import {
  Tab,
  TabProps,
  TonicProps,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';

const CustomTab = <T extends string | number | undefined>(
  props: TabProps<T>
) => {
  const { children, ...rest } = props;
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const baseStyle: TonicProps = {
    backgroundColor: colorStyle.background.secondary,
    color: colorStyle.color.secondary,
    px: '4x',
    py: '3x',
    position: 'relative',
    zIndex: 1,
    _disabled: {
      color: colorStyle.color.disabled,
      cursor: 'not-allowed',
    },
    _hover: {
      color: colorStyle.color.primary,
    },
    borderBottomWidth: 1,
  };

  const styleProps = {
    ...baseStyle,
    border: 1,
    borderColor: colorStyle.divider,
    _notLastOfType: {
      borderRight: 'none',
    },
    _selected: {
      background: colorStyle.background.fourth,
      color: colorStyle.color.primary,
      borderColor: colorStyle.background.fourth,
    },
  };

  return (
    <Tab {...styleProps} {...rest}>
      {children}
    </Tab>
  );
};

export default CustomTab;
